import type { ListOfferRegionFilterExclusionsQuery } from '~/services/PromoService';

export const offerRegionFilterExclusionQueryKeys = {
  all: ['offer-region-filter-exclusions'] as const,
  lists: () => [...offerRegionFilterExclusionQueryKeys.all, 'list'] as const,
  list: (filters: ListOfferRegionFilterExclusionsQuery) =>
    [...offerRegionFilterExclusionQueryKeys.lists(), filters] as const,
};
